module.exports = __webpack_public_path__ + "img/wave_02.602a3e60.png";